import { RETIRE_CARD, RETIRE_CARD_ERROR_MESSAGE, RETIRE_CARD_CLEAR } from '../action/card/retireCard'

const initialState = {
  errorMsg : '',
  retireResult: false
}

export default (state = initialState, action) => {
  const { type, payload } = action
  switch(type) {
    case RETIRE_CARD_ERROR_MESSAGE:
      return {
        ...state,
        errorMsg: 'An error occurred'
      }
    case `${RETIRE_CARD}_FULFILLED`:
      if (payload.resultCode === "0") {
        return {
          ...state,
          retireResult: payload.resultText
        }
      } else {
        return {
          ...state,
          errorMsg: payload.resultText
        }
      }
    case `${RETIRE_CARD}_PENDING`:
      return {
        ...state,
        errorMsg: ''
      }
    case `${RETIRE_CARD}_REJECTED`:
      return {
        ...state,
        errorMsg: 'Cannot connect to server'
      }
    case RETIRE_CARD_CLEAR:
      return {
        initialState
      }
    default:
      return state
  }
}
